import { Component, OnInit, Input } from '@angular/core';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
} from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import Swal from 'sweetalert2';
import { DropDownAnimation } from '../utils/animation';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import socketIOClient from 'socket.io-client';
import moment from 'moment';
import { HttpClient } from '@angular/common/http';
import { MenuToggleService } from '../side-nav.service';
import { BehaviorSubject } from 'rxjs';
import { MessagingService } from '../messaging.service';

const SOCKET_ENDPOINT = environment.socketUrl;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  animations: [DropDownAnimation],
})
export class HeaderComponent implements OnInit {
  currentMessage = new BehaviorSubject(null);

  @Input() type: string;
  isOpen = false;
  userData: any;
  checkAdvertisement: boolean = false;
  user$: any;
  user: any;
  notificationCount: number = 0;
  unreadNotificationCount: number = 0;
  socket!: any;
  allNotifications: any;
  userName: any;
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private http: HttpClient,
    private menuToggleService: MenuToggleService,
    private messageService: MessagingService
  ) {
    this.messageService.getValue().subscribe(() => {
      this.getUserProfile();
    });
  }

  ngOnInit(): void {
    this.getUserProfile();
    this.getContactMessages();
    this.getAnnouncementNotifications();
    this.getUnreadNotificationCount();
    this.addPoint();
    this.authenticationService.userLogin.subscribe((user: any) => {
      if (Object.keys(user).length === 0) {
        const data = { ...localStorage };
        this.user$ = JSON.parse(data.merchant_currentUser1);
      } else {
        this.user$ = user;
      }
    });
  }

  addPoint() {
    this.authenticationService
      .postData('/saveUser/point', { role: 'Merchant' })
      .subscribe(
        (res: any) => { },
        (error: any) => {
          console.log('error', error);
        }
      );
  }
  toggleSideNav() {
    this.menuToggleService.toggleSideNav();
  }
  logout() {
    this.router.navigateByUrl('/login');
    this.authenticationService.logout();
  }
  updateProfile() {
    this.router.navigateByUrl('/update-profile');
  }

  homePage() {
    window.open('https://personal.ravel.faith/', '_blank');
  }

  personalDashboard() {
    window.open('https://personal.ravel.faith/#/home/profile', '_blank');
  }

  redirectTo(type) {
    // if (type == 1) {
    //   if (this.userData.hasSubscription == true) {
    //     Swal.fire('', 'You already have subscribed to base plan', 'success');
    //   }
    // }
  }

  getContactMessages() {
    this.authenticationService
      .contactMessages(`/postChat/getMerchantMessages?chatType=post`)
      .subscribe((res: any) => {
        if (res.code == 200) {
          if (res.data?.length > 0) {
            let notificationCount = 0;
            res.data?.forEach((data: any) => {
              if (data?.unReadMessage > 0) {
                notificationCount += 1;
              }
            });
            this.notificationCount = notificationCount;
          }
        }
      });
  }

  getUserProfile(): void {
    this.authenticationService.getProfile().subscribe(
      (response: any) => {
        this.user = { ...response.data };
        const storedUserStr = localStorage.getItem('merchant_currentUser1');
        let storedUser = {};
        if (storedUserStr) {
          storedUser = JSON.parse(storedUserStr);
        }
        const updatedUser = {
          ...storedUser,
          isActive: this.user.isActive   // or response.data.isActive
        };
        localStorage.setItem(
          'merchant_currentUser1',
          JSON.stringify(updatedUser)
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  navigateToAds(content: any) {
    this.authenticationService.getProfile().subscribe(
      (response: any) => {
        this.user = response.data;
        if (this.user.subscriptions[0]) {
          this.router.navigate(['/advertisements']);
        } else {
          this.modalService.open(content, {
            ariaLabelledBy: 'modal-basic-title',
          });
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }


  userPhoto(url: string) {
    if (!url) {
      return '../../assets/default.png';
    }

    // If it's already a full URL (e.g., Google, Facebook, S3, etc.)
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    // Otherwise, prepend your backend base path
    return `${environment.basePath}${url}`;
  }




  getAnnouncementNotifications() {
    let skip: Number = 0;
    let limit: Number = 10;
    this.authenticationService.getnotifications(skip, limit).subscribe(
      (res: any) => {
        this.allNotifications = res?.items || [];
      },
      (error: any) => {
        console.log('error', error);
        this.allNotifications = [];   // <-- ab empty case bhi handle hoga
      }
    );
  }

  getUnreadNotificationCount() {
    this.authenticationService.getUnreadNotificationCount().subscribe(
      (res: any) => {
        this.unreadNotificationCount = res?.data?.count || 0;
      },
      (error: any) => {
        console.log('error', error);
      }
    );
  }

  markAsRead(notfication: any) {
    if (!notfication || notfication.isRead) {
      return; // already read hai toh dobara call mat karo
    }
    this.authenticationService.markNotificationAsRead(notfication._id).subscribe(
      (res: any) => {
        notfication.isRead = true;
        if (this.unreadNotificationCount > 0) {
          this.unreadNotificationCount--;
        }
      },
      (error: any) => {
        console.log('error', error);
      }
    );
  }
  goToSubscribe() {
    this.router.navigate(['/mysubscration'], {
      queryParams: { isSub: 'true' },
    });
    this.modalService.dismissAll();
  }

  goToDashboard() {
    this.router.navigate(['/dashboard']);
    this.modalService.dismissAll();
  }

  goToChat() {
    this.router.navigate(['/cross-chat']);
  }

  convertTimeAgo(date: any) {
    return moment(date).fromNow();
  }

  imageUrl(url: string) {
    if (url) {
      if (url?.includes(environment.basePath || 'services.ravel.faith')) {
        return url;
      } else {
        // let baseUrl = environment.basePath + url;
        let baseUrl = 'https://services.ravel.faith/' + url;
        return baseUrl;
      }
    } else {
      return 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJVBAe2Ohi5eo9kqXtmXu7iuqreWSQmy195p8ht0tONvjpX7sDBPHgrxQwXiyft-9cgAo&usqp=CAU';
    }
  }

  changeSource(event: any) {
    return (event.target.src =
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTJVBAe2Ohi5eo9kqXtmXu7iuqreWSQmy195p8ht0tONvjpX7sDBPHgrxQwXiyft-9cgAo&usqp=CAU');
  }

  onImgError(event: Event, fallbackSrc: string) {
    const img = event?.target as HTMLImageElement | null;
    if (!img) return;
    // prevent infinite loop if fallback also fails
    if (img.getAttribute('data-fallback-applied') === '1') return;
    img.setAttribute('data-fallback-applied', '1');
    img.src = fallbackSrc;
  }
}
